import { usePermissions } from 'shared/hooks';
import { Brands } from 'shared/types';

export function useBrandRedirect(claims: string, condition: (brands: Brands[]) => boolean) {
  const { brands } = usePermissions(claims);
  return [condition(brands), brands] as const;
}
